import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import * as $ from "jquery";

@Component({
  selector: 'app-vyas-onboarding-page-one',
  templateUrl: './vyas-onboarding-page-one.component.html',
  styleUrls: ['./vyas-onboarding-page-one.component.scss']
})
export class VyasOnboardingPageOneComponent implements OnInit {

  applianceMap: any;
  constructor(private http: HttpClient) { }

  @Input() selectApplianceTypes;
  ngOnInit(): void {
    this.http.get("/assets/json/vyasApplianceList.json").subscribe(applianceMap => {
      this.applianceMap = applianceMap

    })
  }

  toggleAppliance(applianceName, applianceType) {
    this.selectApplianceTypes[applianceName][applianceType]["selected"] = !this.selectApplianceTypes[applianceName][applianceType]["selected"]
  }

}
